import * as theme from '../../../theme';
import TruCard from '../../TruCard';
import AdditionalContentItem from '../items/AdditionalContentItem';
import AdditionalContentContext from '../../../contexts/AdditionalContentContext';

export default function AdditionalContentList({ setActiveContent }) {

  return (
    <TruCard title={'Content List'}>
      {AdditionalContentContext.map((item) => (
        <AdditionalContentItem
          key={item.action}
          action={item.action}
          icon={item.type}
          label={item.title}
          actionLink={() => setActiveContent(item)}
        />
      ))}
    </TruCard>
  );
}